'use client';

import { type FlashState, type FlashStoreApi, createFlashStore } from '@/stores/FlashStore';
import { type ReactNode, createContext, useContext, useState } from 'react';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';

export const FlashStoreContext = createContext<FlashStoreApi | undefined>(undefined);

export function FlashStoreProvider({
  children,
  initialState,
}: {
  children: ReactNode;
  initialState?: Partial<FlashState>;
}) {
  const [store] = useState(() => createFlashStore(initialState));
  return <FlashStoreContext.Provider value={store}>{children}</FlashStoreContext.Provider>;
}

export function useFlashStore<T = FlashState>(selector: (store: FlashState) => T): T {
  const ctx = useContext(FlashStoreContext);
  if (!ctx) {
    throw new Error('useFlashStore must be used within FlashStoreProvider');
  }

  return useStoreWithEqualityFn(ctx, selector, shallow);
}
